/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { createProject, deleteProject } from '@src/apis/project';
import actions from '@src/redux/actions';
import { useTranslation } from 'react-i18next';
import { countTextLength } from '@src/services/tts';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Button } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
import DeleteIcon from '@mui/icons-material/Delete';
import sanitize from 'sanitize-html';
import NotificationDialogV3 from '@src/components/NotificationDialogV3';
import route from '@src/constants/route';
import Table from '@src/components/NewTable';
import { StyledProjectList } from './index.style';
import Header from './Header';
import Actions from './Actions';
import BannerCreateSampleProject from './BannerCreateSampleProject';
import TitleProject from './TitleProject';

const ProjectList = ({
  projects,
  searchProjects,
  loading,
  handleSearchInputChange,
  search,
  onDeleteSuccess,
  total,
  page,
  onChangePage,
  rowsPerPage,
  onChangeRowPage,
  refetchProjects,
  rowsPerPageOptions,
}) => {
  const history = useHistory();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [loadingCreateProject, setLoadingCreateProject] = useState(false);
  const [projectDelete, setProjectDelete] = useState(null);
  const handleCloseActionDialog = () => setProjectDelete(null);
  const handleOpenDeleteDialog = (project) => {
    setProjectDelete(project);
  };

  const handleCreateProject = async (data) => {
    const res = await createProject(data);
    if (res.status) {
      // TODO: show toast
      refetchProjects(false);
    }
    return res;
  };

  const handleCreateSampleProject = async () => {
    const data = {
      title: 'Dự án mẫu',
      product: 'TTS',
      isDeleted: false,
      blocks: [
        {
          id: uuidv4(),
          characters: 0,
          speed: 1,
          elements: [],
        },
      ],
    };
    setLoadingCreateProject(true);
    const res = await handleCreateProject(data);
    if (res.status) {
      setLoadingCreateProject(false);
      const idProject = res?.result?.project?.id;
      history.push(`${route.PROJECTS}/${idProject}`, {
        isSampleProject: true,
      });
    }
    return res;
  };

  const handleConfirmDeleteProject = async (project) => {
    try {
      const idProject = project.id;
      const response = await deleteProject(idProject);
      if (response && response.status) {
        dispatch(
          actions.noti.push({
            severity: 'success',
            message: t('deleteProjectSuccess'),
          }),
        );
        if (onDeleteSuccess) onDeleteSuccess(idProject);
      } else {
        dispatch(
          actions.noti.push({
            severity: 'error',
            message: t('deleteProjectError'),
          }),
        );
      }
    } catch (error) {
      dispatch(
        actions.noti.push({
          severity: 'error',
          message:
            error?.response?.data?.errorMessage || t('deleteProjectError'),
        }),
      );
    }
  };

  const columns = [
    {
      id: 'title',
      field: 'title',
      align: 'left',
      width: '100%',
      cellWidth: '100%',
      render: (row) => (
        <TitleProject
          title={row.title}
          updatedAt={row.updatedAt}
          blocks={row.blocks}
          id={row.id}
          refetchProjects={refetchProjects}
        />
      ),
    },
    {
      id: 'actions',
      field: 'actions',
      width: '100%',
      cellWidth: '100%',
      render: (row) => (
        <Actions
          project={row}
          handleOpenDeleteDialog={() => handleOpenDeleteDialog(row)}
        />
      ),
    },
  ];

  const handleRedirectToProjectDetails = (id) => {
    history.push(`${route.PROJECTS}/${id}`);
  };

  return (
    <StyledProjectList>
      <Header search={search} onSearch={handleSearchInputChange} />
      {!search && projects.length === 0 && !loading ? (
        <BannerCreateSampleProject
          handleCreateSampleProject={handleCreateSampleProject}
          loadingCreateProject={loadingCreateProject}
        />
      ) : (
        <Table
          columns={columns}
          data={search ? searchProjects : projects}
          page={page}
          total={total}
          onChangeRowPage={onChangeRowPage}
          loading={loading}
          rowsPerPage={rowsPerPage}
          onChangePage={onChangePage}
          onRowClick={(id) => handleRedirectToProjectDetails(id)}
          footerPadding="0px 20px 0px"
          isStickyHeader
          isShowCheckbox={false}
          heightTableProjects="425px"
          isExpand
          rowsPerPageOptions={rowsPerPageOptions}
        />
      )}
      {projectDelete && (
        <NotificationDialogV3
          renderIcon={() => (
            <DeleteIcon
              style={{
                color: '#FF3B30',
                fontSize: '24px',
              }}
            />
          )}
          name="delete-project"
          title={t('deleteProject')}
          padding="12px 24px"
          paddingHeader="8px 24px"
          description={sanitize(
            t('deleteProjectDescription', {
              projectName: projectDelete?.title,
            }),
            {
              allowedTags: ['strong'],
            },
          )}
          open={!!projectDelete}
          onClose={() => {
            handleCloseActionDialog();
          }}
          actionComponent={
            <div className="">
              <Button
                className="btn-understood"
                variant="outlined"
                onClick={(e) => {
                  e.stopPropagation();
                  handleCloseActionDialog();
                }}
              >
                {t('cancel')}
              </Button>
              <Button
                className="btn-understood"
                variant="contained"
                onClick={(e) => {
                  e.stopPropagation();
                  handleConfirmDeleteProject(projectDelete || {});
                  handleCloseActionDialog();
                }}
              >
                {t('delete')}
              </Button>
            </div>
          }
        />
      )}
    </StyledProjectList>
  );
};

export default ProjectList;
